/**
 * Removes HTML tags from a string and decodes HTML entities
 * @param text - The HTML string to clean
 * @returns The plain text without HTML tags and with decoded entities
 */
export const stripHtmlTags = (text: string | null | undefined): string => {
  if (!text) return '';

  // Create a temporary DOM element to leverage browser's HTML parsing and entity decoding
  const temp = document.createElement('div');
  temp.innerHTML = text;
  return temp.textContent || temp.innerText || '';
};
